module.exports = __webpack_public_path__ + "img/C04Horseman2_ua.a44f41ab.webp";